export const modalMarginSm = '1.6rem';
export const modalMarginMd = '2.4rem';
export const modalMarginLg = '3.2rem';
